import React from "react";
import theme from "styles/theme";
import { Routes } from "core";
import { ThemeProvider } from "@emotion/react";
import { SnackbarProvider } from "components";
import { QueryClient, QueryClientProvider } from "react-query";
import { NotificationContextProvider } from "context/notificationContext";
import "./../../styles/_main.css";
import { AuthContextProvider } from "context/authContext";
import AppDataProvider from "context/AppContext";

type Props = {};

const App = (props: Props) => {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <AuthContextProvider>
          <AppDataProvider>
            <NotificationContextProvider>
              <Routes />
              <SnackbarProvider />
            </NotificationContextProvider>
          </AppDataProvider>
        </AuthContextProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
